import Card from '../../components/card/Card';
import H from '../../components/texts/h/H';
import P from '../../components/texts/p/P';
import Input from '../../components/input/Input';
import DatePicker from '../../components/datepicker/DatePicker';
import DropDown from '../../components/dropdown/DropDown';
import { MonetizationFormData, FormValues } from '../../pages/MonetizationNew';
import { useEffect } from 'react';

interface CommercialEndorsementsSectionProps {
  formData: MonetizationFormData;
  formValues: FormValues;
  updateFormValues: (updates: Partial<FormValues>) => void;
}

const CommercialEndorsementsSection = ({ formData, formValues, updateFormValues }: CommercialEndorsementsSectionProps) => {
  
  useEffect(() => {
    let updatedFields: Partial<FormValues> = {};
    
    if (formValues.issue_date && formValues.term_in_days !== undefined && formValues.term_in_days !== null) {
      const issueDate = new Date(formValues.issue_date);
      const dueDate = new Date(issueDate);
      dueDate.setDate(dueDate.getDate() + formValues.term_in_days);
      
      const formattedDueDate = dueDate.toISOString().split('T')[0];
      if (formattedDueDate !== formValues.due_date) {
        updatedFields.due_date = formattedDueDate;
        
        if (formattedDueDate !== formValues.estimated_payment_date) {
          updatedFields.estimated_payment_date = formattedDueDate;
        }
      }
    }
    
    if (Object.keys(updatedFields).length > 0) {
      updateFormValues(updatedFields);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formValues.issue_date, formValues.term_in_days]);

  const creditorItems = formData.creditors?.map(creditor => ({
    label: creditor.name,
    disabled: false
  })) || [];

  const purposeTypeItems = formData.purpose_types?.map(type => ({
    label: type.name,
    disabled: false
  })) || [];

  const handleCreditorChange = (selectedLabel: string) => {
    const creditor = formData.creditors?.find(c => c.name === selectedLabel);
    if (creditor) {
      updateFormValues({ creditor_id: creditor.id });
    }
  };

  const handlePurposeTypeChange = (selectedLabel: string) => {
    const purposeType = formData.purpose_types?.find(p => p.name === selectedLabel);
    if (purposeType) {
      updateFormValues({ purpose_type_id: purposeType.id });
    }
  };

  const getSelectedCreditor = () => {
    const creditor = formData.creditors?.find(c => c.id === formValues.creditor_id);
    return creditor?.name || 'Seleccionar';
  };

  const getSelectedPurposeType = () => {
    const purposeType = formData.purpose_types?.find(p => p.id === formValues.purpose_type_id);
    return purposeType?.name || 'Seleccionar';
  };

  return (
    <>
      <Card margin={{ bottom: '4' }}>
        <Card margin={{ bottom: '3' }}>
          <H variant="secondary-2" type='4' weight='bold' modifier='strong'>
            Datos del aval comercial
          </H>
        </Card>
        
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px', marginBottom: '24px', alignItems: 'end' }}>
          <Input
            label="Monto bruto *"
            type="number"
            value={formValues.monetization_amount?.toString() || ''}
            onChange={(e) => updateFormValues({ monetization_amount: parseFloat(e.target.value) || null })}
            size="md"
            inputStatus="normal"
          />
          <Input
            label="Divisa"
            value={formData.currency}
            readOnly
            size="md"
            modifier="weak"
          />
          <Card>
            <P withMargin={false} variant='neutral' type='4' modifier='strong'>
              Fecha de emisión *
            </P>
            <Card margin={{ top: '2' }}>
              <DatePicker
                defaultValue={formValues.issue_date}
                onChange={(date: string) => updateFormValues({ issue_date: date })}
                disabled={false}
                displayFormat="DD/MM/AA"
              />
            </Card>
          </Card>
          <Card>
            <P withMargin={false} variant='neutral' type='4' modifier='weak'>
              Fecha de vencimiento *
            </P>
            <Card margin={{ top: '2' }}>
              <DatePicker
                defaultValue={formValues.due_date}
                onChange={() => {}} 
                disabled={true}
                displayFormat="DD/MM/AA"
              />
            </Card>
          </Card>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px', marginBottom: '24px', alignItems: 'end' }}>
          <DropDown
            id="creditor"
            label="Acreedor *"
            title={getSelectedCreditor()}
            items={creditorItems}
            onChange={handleCreditorChange}
            size="md"
            marginTop="4px"
          />
          <Input
            label="Plazo en dias *"
            type="number"
            value={formValues.term_in_days?.toString() || ''}
            onChange={(e) => {
              const value = e.target.value;
              const numValue = value === '' ? 0 : parseInt(value);
              if (!isNaN(numValue)) {
                updateFormValues({ term_in_days: numValue });
              }
            }}
            size="md"
            inputStatus="normal"
          />
          <DropDown
            id="purpose_type"
            label="Destino *"
            title={getSelectedPurposeType()}
            items={purposeTypeItems}
            onChange={handlePurposeTypeChange}
            size="md"
            marginTop="4px"
          />
          <Card>
            <P withMargin={false} variant='neutral' type='4' modifier='weak'>
              Fecha estimada de pago *
            </P>
            <Card margin={{ top: '2' }}>
              <DatePicker
                defaultValue={formValues.estimated_payment_date || new Date().toISOString().split('T')[0]}
                onChange={() => {}}
                disabled={true}
                displayFormat="DD/MM/AA"
              />
            </Card>
          </Card>
        </div>
      </Card>
    </>
  );
};

export default CommercialEndorsementsSection;
